/* eslint-disable react/prop-types */
import React, { useState } from "react";
import axios from "axios";
import { Row, Col, Button } from "react-bootstrap";
import FadeIn from "../../common/FadeIn";

const BulkHideOrView = (props) => {
  const [confirmHide, setConfirmHide] = useState(false);
  const [confirmReveal, setConfirmReveal] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const Venue = props.venueID;

  const hideAll = async (e) => {
    e.preventDefault();
    const data = {
        Venue
    };

    setSubmitClicked(true);

    const hideAllRequest = await axios.put(
        `/api/admin/edit_class/bulk_hide`, data,
        {
          withCredentials: true,
        }
      );

        if (hideAllRequest.status === 200) {
            props.setSuccessMessage("All classes at this venue have been hidden.");
            setSubmitClicked(false);
            setConfirmHide(false);
            return props.fetchNewData();
        } else {
            setSubmitClicked(false);
            return props.setErrorMessage("There was a problem with your request.");
        }
    };

    const revealAll = async (e) => {
        e.preventDefault();
        const data = {
            Venue
        };
        
        setSubmitClicked(true);

        const revealAllRequest = await axios.put(
            `/api/admin/edit_class/bulk_reveal`, data,
            {
                withCredentials: true,
            }
        );

        if (revealAllRequest.status === 200) {
            props.setSuccessMessage("All classes at this venue have been revealed.");
            setSubmitClicked(false);
            setConfirmReveal(false);
            return props.fetchNewData();
        } else {
            setSubmitClicked(false);
            return props.setErrorMessage("There was a problem with your request.");
        }
    };

  return (
    <FadeIn delay={250} duration={450}>
        <Row className="border mt-4 text-center p-4">
          <Col className="mt-2 mb-2">
            <h2>Bulk Hide / Reveal</h2>
            <span className="mt-2">
              Use these buttons to hide or reveal all classes at this venue. You
              will have to individually edit classes if you want to make
              exceptions.
            </span>
          </Col>
          <Col sm="12">
            {!confirmHide && !confirmReveal && (
              <>
                <Button
                  className="mt-2 mb-2"
                  variant="danger"
                  onClick={() => setConfirmHide(true)}
                  disabled={submitClicked}
                >
                  Hide All
                </Button>
                <Button 
                    className="ms-2 mt-2 mb-2"
                    variant="danger"
                    onClick={() => setConfirmReveal(true)}
                    disabled={submitClicked}
                >
                    Reveal All
                </Button>
              </>
            )}

            {confirmHide && (
              <>
                <Button
                  className="mt-2 mb-2"
                  variant="danger"
                  onClick={() => setConfirmHide(false)}
                  disabled={submitClicked}
                >
                  Cancel
                </Button>{" "}
                <Button
                  className="ms-2 mt-2 mb-2"
                  variant="success"
                  onClick={(e) => hideAll(e)}
                  disabled={submitClicked}
                >
                  Confirm
                </Button>
              </>
            )}

            {confirmReveal && (
                <>
                    <Button
                        className="mt-2 mb-2"
                        variant="danger"
                        onClick={() => setConfirmReveal(false)}
                        disabled={submitClicked}
                    >
                        Cancel
                    </Button>{" "}
                    <Button
                        className="ms-2 mt-2 mb-2"
                        variant="success"
                        onClick={(e) => revealAll(e)}
                        disabled={submitClicked}
                    >
                        Confirm
                    </Button>
                </>
            )}
          </Col>
        </Row>
    </FadeIn>
  );
};

export default BulkHideOrView;
